import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { social } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import TopThreeHero from "../components/leaderboard/TopThreeHero";
import RecentDeedsSection from "../components/leaderboard/RecentDeedsSection";
import LeaderboardRow from "../components/leaderboard/LeaderboardRow";
import LoadingOverlay from "../components/LoadingOverlay";

export default function LeaderboardPage() {
  const { user } = useAuth();
  const location = useLocation();
  const [entries, setEntries] = useState([]);
  const [recentDeeds, setRecentDeeds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    Promise.all([social.getLeaderboard(), social.getRecentDeeds()])
      .then(([lb, deeds]) => {
        setEntries(lb.leaderboard || []);
        setRecentDeeds(deeds.recent_deeds || []);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [location.key]);

  if (loading) return <LoadingOverlay />;

  const topThree = entries.slice(0, 3);
  const rest = entries.slice(3);

  return (
    <div>
      <RecentDeedsSection deeds={recentDeeds} />
      <h2 className="font-display text-lg font-semibold text-walnut mb-3">Leaderboard</h2>
      <TopThreeHero entries={topThree} currentUserId={user?.id} />
      {rest.length > 0 && (
        <>
          <div className="space-y-2">
            {rest.map((entry, i) => (
              <LeaderboardRow
                key={entry.user.id}
                entry={entry}
                currentUserId={user?.id}
                animationDelay={700 + i * 50}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
